import {getStayAverageData, getStayAverageByDate} from '../../../api/adminDist/stayAverageApi'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'

const state = {
  stayAverageData: [],
  stayAverageByDate: []
}

const getters = {
  getStayAverageData(state){
    return state.stayAverageData
  },

  getStayAverageByDate(state){
    return state.stayAverageByDate
  }
}

const actions = {
  async getStayAverageData({commit}, condition ={}) {
    const result = await getStayAverageData(condition)
    if(result.success) {
      commit('stayAverageData', result.body)
    }
  },

  async getStayAverageByDate({commit}, condition ={}) {
    const result = await getStayAverageByDate(condition)
    if(result.success) {
      commit('stayAverageByDate', result.body)
    }
  }
}

const mutations = {
  stayAverageData(state, data) {
    state.stayAverageData = data
  },

  stayAverageByDate(state, data) {
    state.stayAverageByDate = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}